import { Typography } from '@mui/material';
import { styled } from '@mui/system'

import { location } from '../../../../assets/images/svgs';
import { getAnalytics, logEvent } from "firebase/analytics";

export const DivContainer = styled('div')((props) => ({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: '4px 0px',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    '.image-container': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginLeft: 30,
        [props.theme.breakpoints.down('sm')]:{
            marginLeft:10
        }
    },
    '.location-container': {
        textDecoration: 'none',
        display: 'flex',
        flexDirection: 'row',
        color: 'black',
        marginRight: 8,
        alignItems: 'center',
        cursor: 'pointer',
        [props.theme.breakpoints.down(620)]: {
            display: 'none'
        }
    },
    '.contact-us-text': {
        padding: 5
    },
    '.contact-us-number': {
        cursor: 'pointer',
        backgroundColor: '#fa6943',
        color: 'white',
        borderRadius: 25,
        marginRight: 30,
        padding: '4px 15px',
        fontWeight: 600,
        [props.theme.breakpoints.down('sm')]:{
            fontSize:20,
            marginRight:10
        }
    }

}))


export const Header = () => {
    const analytics = getAnalytics();
    const onClickLocation = () => {
        logEvent(analytics, 'on_click_location')
        window.location.href = 'https://goo.gl/maps/P6YWaKVxW3G2ZGcZ6'
    }

    const onClickNumber = () => {
        logEvent(analytics, 'on_click_number')
        window.location.href = "tel:+91-9910470476"
    }
    return (
        <DivContainer>
            <div className="image-container">
                <img src={require('../../../../assets/images/furry-fort-icon.png')} width={40} height={40} />
                <Typography variant="body1" style={{ fontWeight: 600, textAlign: 'center' }}>Furry Fort</Typography>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', alignItems: 'center' }}>
                <div className="location-container" onClick={onClickLocation}>
                    {location}
                    <Typography style={{ marginLeft: 4 }}>68p,Sector 46, Gurgaon</Typography>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography className="contact-us-text">Contact Us:</Typography>
                    <Typography
                    className="contact-us-number"
                        onClick={onClickNumber}
                    >
                        +91-8826721342
                    </Typography>
                </div>
            </div>
        </DivContainer>
    )
}